import { render, staticRenderFns } from "./TInput.vue?vue&type=template&id=7e12874d&scoped=true&"
import script from "./TInput.vue?vue&type=script&lang=js&"
export * from "./TInput.vue?vue&type=script&lang=js&"
import style0 from "./TInput.vue?vue&type=style&index=0&id=7e12874d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12874d",
  null
  
)

export default component.exports